import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = { class: "page-container card col-md-8" }
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "row p-3" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "row p-3 pb-0" }, [
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Search existing Company by:")
  ])
], -1)
const _hoisted_10 = { class: "row p-3 pb-0" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "row p-3 pb-0" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "row p-3" }
const _hoisted_17 = { class: "col-md-5 d-flex align-items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_19 = { class: "col-md-7" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-12 p-4" }
const _hoisted_22 = { class: "p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12" }
const _hoisted_23 = { class: "p-datatable-thead" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"8%"} }, "#", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }, "Legal Parent ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("th", {
  style: {"width":"15%"},
  class: "text-center"
}, "Status", -1)
const _hoisted_27 = {
  key: 0,
  class: "p-datatable-tbody"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = {
  key: 0,
  class: "error-no-record"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_TheTableLoading = _resolveComponent("TheTableLoading")!
  const _component_TheInvalidImportDialog = _resolveComponent("TheInvalidImportDialog")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_ThePageHeader, {
                onImportEvent: _ctx.importFile,
                onExportEvent: _ctx.exportFile,
                renderImport: !_ctx.isLoading,
                renderExport: !_ctx.isLoading,
                isImporting: _ctx.isImporting,
                isExporting: _ctx.isExporting
              }, null, 8, ["onImportEvent", "onExportEvent", "renderImport", "renderExport", "isImporting", "isExporting"]),
              (_ctx.pageError == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_Button, {
                          class: "p-button-sm",
                          onClick: _ctx.add,
                          label: "Create New Company"
                        }, null, 8, ["onClick"])
                      ])
                    ]),
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_InputText, {
                          class: "p-inputtext",
                          type: "text",
                          maxlength: "10",
                          placeholder: "Code",
                          modelValue: _ctx.filterCodeModel.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterCodeModel.value) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_InputText, {
                          class: "p-inputtext",
                          type: "text",
                          maxlength: "100",
                          placeholder: "Name",
                          modelValue: _ctx.filterNameModel.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterNameModel.value) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_Dropdown, {
                          options: _ctx.getActiveStatuses(_ctx.statuses),
                          optionLabel: "name",
                          optionValue: "value",
                          placeholder: "Status",
                          modelValue: _ctx.filterStatusModel.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterStatusModel.value) = $event))
                        }, null, 8, ["options", "modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_Dropdown, {
                          options: _ctx.currencies,
                          optionLabel: "code",
                          optionValue: "identifier",
                          filter: "",
                          filterFields: ['code'],
                          showClear: "",
                          placeholder: _ctx.isCurrencyLoading ? ('Loading...') : 'Currency',
                          loading: _ctx.isCurrencyLoading,
                          modelValue: _ctx.filterCurrencyModel.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterCurrencyModel.value) = $event))
                        }, null, 8, ["options", "placeholder", "loading", "modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_Button, {
                          class: "p-button-sm",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.find(1))),
                          label: "Search"
                        }),
                        _hoisted_18,
                        _createVNode(_component_Button, {
                          class: "p-button-sm p-button-secondary",
                          onClick: _ctx.reset,
                          label: "Reset"
                        }, null, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        (_ctx.pagination.currentPage != 0)
                          ? (_openBlock(), _createBlock(_component_Paginator, {
                              key: 0,
                              first: _ctx.paginator,
                              pageLinkSize: 3,
                              rows: _ctx.pagination.itemsPerPage,
                              totalRecords: _ctx.pagination.totalItems,
                              onPage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.find($event.page + 1)))
                            }, null, 8, ["first", "rows", "totalRecords"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("table", _hoisted_22, [
                          _createElementVNode("thead", _hoisted_23, [
                            _createElementVNode("tr", null, [
                              _hoisted_24,
                              _createElementVNode("th", {
                                style: {"width":"15%","cursor":"pointer"},
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sort('x.code')))
                              }, [
                                _createTextVNode("Code "),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.code' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                }, null, 2)
                              ]),
                              _createElementVNode("th", {
                                style: {"width":"32%","cursor":"pointer"},
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sort('x.name')))
                              }, [
                                _createTextVNode("Name "),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.name' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                }, null, 2)
                              ]),
                              _hoisted_25,
                              _createElementVNode("th", {
                                style: {"width":"15%","cursor":"pointer"},
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sort('x.currency.code')))
                              }, [
                                _createTextVNode("Currency "),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.currency.code' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                }, null, 2)
                              ]),
                              _hoisted_26
                            ])
                          ]),
                          (!_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("tbody", _hoisted_27, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagination.companies, (company, index) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: index,
                                    onClick: ($event: any) => (_ctx.view(company))
                                  }, [
                                    _createElementVNode("td", null, _toDisplayString(((_ctx.pagination.currentPage - 1) * _ctx.pagination.itemsPerPage) + index + 1), 1),
                                    _createElementVNode("td", null, _toDisplayString(company.code), 1),
                                    _createElementVNode("td", null, _toDisplayString(company.name), 1),
                                    _createElementVNode("td", null, _toDisplayString(company.parent), 1),
                                    _createElementVNode("td", null, _toDisplayString(company.currency), 1),
                                    _createElementVNode("td", _hoisted_29, [
                                      _createVNode(_component_Badge, {
                                        class: _normalizeClass(["mr-2", [company.status == 'Active' ? 'p-badge-success' : 'p-badge-danger']]),
                                        value: company.status
                                      }, null, 8, ["class", "value"])
                                    ])
                                  ], 8, _hoisted_28))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (!_ctx.isLoading && _ctx.pagination.companies.length == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createVNode(_component_FontAwesomeIcon, {
                              icon: ['fas', 'image'],
                              size: "2x"
                            }),
                            _hoisted_31
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isLoading)
                        ? (_openBlock(), _createBlock(_component_TheTableLoading, { key: 1 }))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_TheInvalidImportDialog, {
                title: "Company",
                visible: _ctx.isDialogVisible,
                data: _ctx.invalidData,
                onCloseDialogEvent: _ctx.closeDialog,
                onProceedImportEvent: _ctx.proceedImport
              }, null, 8, ["visible", "data", "onCloseDialogEvent", "onProceedImportEvent"]),
              (_ctx.pageError != '')
                ? (_openBlock(), _createBlock(_component_ThePageError, {
                    key: 1,
                    onBackEvent: _ctx.cancel,
                    pageError: _ctx.pageError
                  }, null, 8, ["onBackEvent", "pageError"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ])
  ], 64))
}